<template  >
<v-layout column fill-height="">

    <not-toolbar-sub :not="not"></not-toolbar-sub>

    <!-- //access page -->
    <not-access-deny-page 
        v-if="!accessPage"
        :not="not"
        :notShow="true"/> 
    <!-- //page -->
    <v-layout column="" fill-height="" v-else>
        <not-page-spinner 
            :notShow="true" 
            :not="not"
            v-if="!page_show"/> 
        <div v-else class="ma-10 ">
            <v-toolbar color="primary" dark="" tile=""  >
                <v-toolbar-title>
                    MANAGE PARTIES
                </v-toolbar-title>
                <v-spacer></v-spacer> 
                <v-btn @click="addParty()" color="white" outlined="" rounded="" class="mr-2"><v-icon size="18" class="pr-1">mdi-plus-thick</v-icon> Add Party</v-btn>
                <v-menu  bottom left 
                    v-model="menuParties"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                    <v-btn
                        dark outlined="" rounded=""
                        icon
                        v-on="on" >
                        <v-icon>mdi-tune</v-icon>
                    </v-btn>
                    </template>

                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                CUSTOMIZE TABLE
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuParties=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_parties" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeader_parties,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuParties = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text>
                        
                    </v-card> 
                </v-menu>
                <v-menu bottom left >
                    <template v-slot:activator="{ on }">
                    <v-btn 
                        dark
                        icon
                        v-on="on" >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>

                    <v-list> 
                        <v-list-item  @click="menuParties=true" >
                            <v-list-item-title>Customize Table</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="addParty()" >
                            <v-list-item-title>Add Parties Manually</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="onExcelSelect()" >
                            <v-list-item-title>Import Parties from Excel</v-list-item-title>
                        </v-list-item>
                        <v-list-item   >
                            <v-list-item-title>Export Parties</v-list-item-title>
                        </v-list-item> 
                        <v-list-item  @click="deleteAllParties()" >
                            <v-list-item-title>Delete All Parties</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> 
            </v-toolbar>
            <v-card v-if="parties" class="pa-2" tile="">
                <v-card-title>
                    Parties 
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>

                <!-- //CHECK PARTIES READ ACCESS -->

                <div v-if="accessParties('read')">
                    <v-data-table
                        :headers="headers('party')"
                        :items="JOINED_parties"
                        :search="search" >

                        <template v-slot:top>
                            
                        </template>
                        <template v-slot:item.image="{ item }" > 
                            <v-list-item-avatar :tile="false">
                                <div v-if="item.image_link">
                                    <v-list-item-avatar size="50">
                                        <v-img :src="item.image_link" />  
                                    </v-list-item-avatar>
                                </div>
                                <div v-else>
                                    <v-list-item-avatar size="50" color="b2">
                                <!-- <v-img :src="'https://cdn.vuetifyjs.com/images/lists/1.jpg'" />   -->
                                    </v-list-item-avatar>
                                </div>
                            </v-list-item-avatar>
                        </template>
                        <template v-slot:item.action="{ item }" > 
                            
                            <v-hover v-slot:default="{hover}" class="ma-1">
                                <v-avatar tile color="primary" class="pa-1">
                                    <v-icon size="18" dark @click="editParty(item)" :class="hover?'white':''" :color="hover?'primary':'white'">mdi-pencil</v-icon>
                                </v-avatar>
                            </v-hover> 
                            <v-hover v-slot:default="{hover}" class="ma-1">
                                <v-avatar tile color="red" class="pa-1" >
                                    <v-icon size="18" dark @click="deleteParty(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-close</v-icon>
                                </v-avatar>
                            </v-hover> 
                        </template>
                        <template v-slot:no-data>
                            <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                <v-icon>warning</v-icon>
                                Empty
                            </v-layout>
                        </template>
                    </v-data-table> 
                </div>
                    <div v-else>
                        <v-layout  justify-center="" align-center="" class=" primary lighten-4 mx-2 pa-5 ">
                            <v-icon size="50" color="primary">mdi-shield-account</v-icon>
                            <div>You have no parties read permission</div> 
                        </v-layout> 
                    </div>
            </v-card> 
        </div> 
    </v-layout>


    <!-- ADD -->
    <v-dialog v-model="dialog_add_party" persistent max-width="800px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">ADD NEW PARTY</span>
                <v-spacer></v-spacer>
                <v-btn v-if="!isAutoCode(inputCode)" @click="setAutoCode()" color="white" outlined="" rounded="" class="ml-2">AUTO GENERATE CODE</v-btn>
                <v-btn @click="onExcelSelect()" color="white" outlined="" rounded="" class="ml-2"><v-icon size="" class="pr-1">mdi-file-excel-outline</v-icon> EXCEL</v-btn>
                <v-btn class="ml-2" dark @click="dialog_add_party=false" icon=""><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submited()">
                        <v-layout row wrap class="pa-1">   
                            <!-- Title -->
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.name" 
                                    label="Name"/>  
                            </v-flex>  

                            <v-flex xs12 md6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.party_short_name" 
                                    label="Short Name"/>  
                            </v-flex>  
                            <v-flex xs12 md6> 
                                <v-text-field 
                                    required  
                                    type="number"
                                    filled=""
                                    v-model="inputCode" 
                                    label="Code"/>  
                            </v-flex> 
                            <v-flex xs12 md6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.color_code" 
                                    label="Color Code"/>  
                            </v-flex> 
                            <v-flex xs12 md6> 
                                <v-text-field  
                                    type="text"
                                    filled=""
                                    v-model="input.image_link" 
                                    label="Image Link"/>  
                            </v-flex> 
                            
                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_add_party=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input.loading" dark="" type="submit">Save</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click Excel button to add a new party using excel template and selecting parties excel file</small>
            </v-card-text> 
        </v-card>
    </v-dialog>

    <!-- EDIT -->
    <v-dialog v-model="dialog_edit_party" persistent max-width="600px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">EDIT PARTY</span>
                <v-spacer></v-spacer>   
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submitedEdit()">
                        <v-layout row wrap class="pa-1">   
                            <!-- Title -->
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.name" 
                                    label="Name"/>  
                            </v-flex>  
                            <v-flex xs12 md6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.party_short_name" 
                                    label="Short Name"/>  
                            </v-flex>  
                            <v-flex xs12 md6> 
                                <v-text-field 
                                    disabled=""  
                                    type="text"
                                    filled=""
                                    v-model="inputCode" 
                                    label="Code"/>  
                            </v-flex>  
                            <v-flex xs12 md6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.color_code" 
                                    label="Color Code"/>  
                            </v-flex> 
                            <v-flex xs12 md6> 
                                <v-text-field  
                                    type="text"
                                    filled=""
                                    v-model="input.image_link" 
                                    label="Image Link"/>  
                            </v-flex> 
                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_edit_party=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input.loading" dark="" type="submit">Save</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click save button to changes</small>
            </v-card-text> 
        </v-card>
    </v-dialog>

    <!-- select -->
    <div v-if="excelSelecter">
        <not-selecter-excel 
            :notShow="excelSelecter"
            @notNo="excelSelecter =!excelSelecter"
            @notYes="fileSelected"/>
    </div>

    <!-- Selected -->
    <v-dialog v-model="dialog_selected_parties" persistent max-width="900px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">UPLOAD PARTIES</span>
                <v-spacer></v-spacer>
                <v-btn v-if="!not.CODE_IS_AUTO(EXCEL_JS_parties)" @click="EXCEL_JS_parties=not.CODE_AUTO_GENERATE(EXCEL_JS_parties)" rounded="" outlined="" dark>Auto Generate Code</v-btn>
                <v-btn  @click="dialog_selected_parties=false" color="white" icon="" class="ml-2"><v-icon size="" class="pr-1">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <v-data-table
                        :headers="headers('excel')"
                        :items="JOINED_XL_parties"  >

                        <template v-slot:top>
                            
                        </template> 

                        <template v-slot:item.action="{ item }" > 
                            
                            <v-hover v-slot:default="{hover}" class="ma-1">
                                <v-avatar tile color="primary" class="pa-1">
                                    <v-icon size="18" dark @click="editXlDistrict(item)" :class="hover?'white':''" :color="hover?'primary':'white'">mdi-pencil</v-icon>
                                </v-avatar>
                            </v-hover> 
                            <v-hover v-slot:default="{hover}" class="ma-1">
                                <v-avatar tile color="red" class="pa-1" >
                                    <v-icon size="18" dark @click="deleteXlDistrict(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-close</v-icon>
                                </v-avatar>
                            </v-hover> 
                        </template>
                        <template v-slot:no-data>
                            <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                <v-icon>warning</v-icon>
                                Empty
                            </v-layout>
                        </template>
                    </v-data-table> 
                </v-container>
                <v-divider></v-divider>
                <br>
                <v-layout justify-center=""> 
                    <!-- <v-btn :loading="input.loading" @click="uploadXl()" color="primary lighten-3" class="mr-2" ><v-icon class="mr-2">mdi-cloud-sync</v-icon> UPLOAD TO OLD LIST</v-btn> -->
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog_selected_parties=false" color="primary" text="">CANCEL</v-btn>
                    <v-btn :loading="input.loading" @click="uploadXlNew()" color="primary "><v-icon class="mr-2">mdi-cloud-upload</v-icon> UPLOAD PARTIES</v-btn>
                </v-layout>
            </v-card-text> 
      </v-card>
    </v-dialog>
</v-layout>
</template>

<script> 
    
    let pageName = 'Party'
    let ACTION_TIME = 100
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
            page_show_parties: false,

            menuParties:false,
            dialog_add_party:false,
            dialog_edit_party:false,
            dialog_selected_parties:false,
            excelSelecter:false,
            EXCEL_JS_parties:[],
            inputCode:null,
            input:{},
            search: '',
            xHeader_parties:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Image",show:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Name",show:true}, 
                {id:0,name:"Code",show:true}, 
                {id:0,name:"Color Code",show:true}, 

                {id:0,name:"Short Name",show:true}, 
                {id:0,name:"Candidate Name",show:true}, 
                {id:0,name:"Candidate Code",show:false},  
                {id:0,name:"Image Link",show:false},  
 
                {id:0,name:"Added By",show:false}, 
                {id:0,name:"Added At",show:false}, 
                {id:0,name:"Updated At",show:false},
                {id:26,name:"ACTION",show:true},  
            ],
            xHeader_parties2:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Image",show:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Name",show:true}, 
                {id:0,name:"Short Name",show:true},  
                {id:0,name:"Code",show:true},   
                {id:0,name:"Color Code",show:true}, 
                {id:0,name:"Image Link",show:true},  
                {id:26,name:"ACTION",show:true},  
            ],
             
             
        }),  
        created(){
            this.EventBus.$on('notYesDialog', this.notYesDialog); 
        },
        mounted() {   
            this.pageLoad(1000)
        },
        computed:{ 
            accessParties(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("parties") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("parties") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("parties") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("parties") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            ud(){
                return this.not.ud
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            parties(){
                return this.$store.getters.getParties
            },
            JOINED_parties(){
                let parties = this.parties
                let joinedParties = this.not.JOIN_PARTIES(parties)
                return joinedParties
            },
            JOINED_XL_parties(){
                let parties = this.EXCEL_JS_parties
                return this.not.JOIN_PARTIES(parties)  
            }
            
        },
        //------------methods---------------
        methods: { 
            clicked(){ 
            },
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+'=ADD-PARTY') {
                        if (this.input.check) { 
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_add",{
                                    action:"party",
                                    path:"/Parties/",
                                    data:action.details,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);   
                        } 
                    }  
                    if (action.code ===pageName+'=EDIT-PARTY') {
                        if (this.input.check) {  
                            this.input.check = false
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_update",{
                                    action:"party",
                                    path:"/Parties/"+action.details.key+"/",
                                    data:action.details,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);   
                        } 
                    } 
                    if (action.code ===pageName+'=ADD-PARTY-SUCCESS') {
                        this.dialog_add_party = false
                    }
                    if (action.code ===pageName+'=EDIT-PARTY-SUCCESS') {
                        this.dialog_edit_party = false
                    }

                    if (action.code ===pageName+'=CONFIRM-DELETE-PARTY') {
                        if (this.input.check) {  
                            setTimeout(() => { 
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting this party","CANCEL","CONFIRM",{
                                    ...action,
                                    code:pageName+"=DELETE-PARTY",
                                }) 
                            }, ACTION_TIME);
                        }  
                    } 
                    if (action.code ===pageName+"=CONFIRM-DELETE-ALL-PARTIES") {
                        if (this.input.check) {  
                            setTimeout(() => {
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting all parties. This action can not be reversed","CANCEL","CONFIRM",{
                                    ...action,
                                    code:pageName+"=DELETE-ALL-PARTIES",
                                })  
                            }, ACTION_TIME);
                        }   
                    } 
                    
                    if (action.code ===pageName+'=DELETE-PARTY') {
                        if (this.input.check) {  
                            this.input.check = false
                            setTimeout(() => {
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered","OK")
                                } else {
                                    this.$store.dispatch("fi_delete",{
                                        action:"party",
                                        path:"/Parties/"+action.party.key+"/"
                                    })    
                                } 
                            }, ACTION_TIME);   
                        }   
                    } 
                    if (action.code ===pageName+'=DELETE-ALL-PARTIES') {
                        if (this.input.check) {  
                            this.input.check = false
                            setTimeout(() => {
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered","OK")
                                } else {
                                    this.$store.dispatch("fi_delete",{
                                        action:"party",
                                        path:"/Parties/" 
                                    })     
                                }  
                            }, ACTION_TIME);   
                        }   
                    } 


                    if (action.code ===pageName+'=SELECT-EXCEL') {
                        this.onExcelSelect()  
                    } 
                    if (action.code ===pageName+'=REMOVE-XL-PARTY') {
                        let party =action.party 
                        let parties = this.EXCEL_JS_parties
                        this.EXCEL_JS_parties = parties.filter(ds=>{
                            return ds.code != party.code
                        }) 
                    } 

                    if (action.code ===pageName+'=XL-UPLOAD-NEW') {
                        if (this.input.check) {  
                            this.input.loading = true 
                            this.$store.dispatch("fi_set",{
                                action:"parties",
                                path:"/Parties/",
                                data:this.EXCEL_JS_parties,
                                us:this.us,
                                array:true
                            }) 
                        }  
                    } 

                    if (action.code ===pageName+'=AUTO-GENERATE-CODE') { 
                        this.EXCEL_JS_parties= this.not.CODE_AUTO_GENERATE(this.EXCEL_JS_parties) 
                        setTimeout(() => { 
                            this.not.notDialog(true,true,'GENERATED',"Codes, successfully generated.","OK")
                        }, ACTION_TIME);
                    } 
                    if (action.code ===pageName+'=AUTO-SET-CODE') { 
                        this.inputCode = (this.not.CODE_GET_LAST(action.data)+1)
                        setTimeout(() => { 
                            this.not.notDialog(true,true,'GENERATED',"Code, successfully generated.","OK") 
                        }, ACTION_TIME);
                    }
                }
            },
            addParty(){
                let p = this.accessParties("write")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you have no parties write permission. Contact system admin for more info.","OK") 
                } else {
                    this.inputCode = null
                    this.input = {}
                    this.dialog_add_party = true
                } 
            },
            submited(){
                //convert code to int
                let code = this.inputCode*1 
                let array = this.parties

                //check code
                if (code === 0) {
                    this.not.notDialog(true,true,"ERROR CODE",'Code can not be zero (0). Try another code or click AUTO GENERATE CODE BUTTON to generate a uniquecode.','CANCEL',"AUTO GENERATE CODE",{
                        code:pageName+"=AUTO-SET-CODE",
                        data:array
                    }) 
                    return
                }
                if (this.not.CODE_CHECK(array,code)) {
                    this.not.notDialog(true,true,"ERROR CODE",'This Code has already been used. Try another code or click AUTO GENERATE CODE BUTTON to generate a uniquecode.','CANCEL',"AUTO GENERATE CODE",{
                        code:pageName+"=AUTO-SET-CODE",
                        data:array
                    }) 
                    return
                } 
                if (!this.input) {
                    this.not.notDialog(true,true,"ERROR","Make sure you filled the form and try again","OK")
                }else{
                    this.input.code = code
                    this.input.check = true
                    this.not.notDialog(true,true,"ADD PARTY",'Are you sure you want to add this party?','CANCEL',"ADD",{
                        code:pageName+"=ADD-PARTY",
                        details:this.input
                    }) 
                }
            },
            editParty(party){
                let p = this.accessParties("edit")  
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you have no parties edit permission. Contact system admin for more info.","OK") 
                } else {
                    this.inputCode = null
                    this.input = {}
                    this.input.name = party.name
                    this.input.party_short_name = party.party_short_name
                    this.inputCode = party.code 
                    this.input.key = party.key 
                    this.input.color_code = party.color_code 
                    this.input.image_link = party.image_link 
                    this.dialog_edit_party = true
                }  
            },
            submitedEdit(){
                this.input.check = true
                this.not.notDialog(true,true,"EDIT PARTY",'Are you sure you want to edit this party?','CANCEL',"EDIT",{
                    code:pageName+"=EDIT-PARTY",
                    details:this.input
                }) 
            },
            deleteParty(party){
                let p = this.accessParties("delete") 
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you have no parties delete permission. Contact system admin for more info.","OK") 
                } else {
                    this.input.check = true 
                    this.not.notDialog(true,true,"DELETE PARTY",'Are you sure you want to delete this party?','CANCEL',"DELETE",{
                        code:pageName+"=CONFIRM-DELETE-PARTY",
                        party:party
                    })  
                } 
            },
            deleteAllParties(){
                let p = this.accessParties("delete") 
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you have no parties delete permission. Contact system admin for more info.","OK") 
                } else {
                    this.input.check = true
                    this.not.notDialog(true,true,"DELETE ALL",'Are you sure you want to delete all uploaded Parties?','CANCEL',"DELETE",{
                        code:pageName+"=CONFIRM-DELETE-ALL-PARTIES",
                    }) 
                }  
            },

            //Heades
            headers(type){
                let hds = null
                if (type === 'party') {
                    hds = this.xHeader_parties
                }else if (type === 'excel'){
                    hds = this.xHeader_parties2
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },
            setAutoCode(){ 
                let code = this.not.CODE_GET_LAST(this.parties) 
                this.inputCode= (code+1 )
                this.not.notDialog(true,true,'GENERATED',"Code, successfully generated.","OK") 
            },
            isAutoCode(number){ 
                let code = this.not.CODE_GET_LAST(this.parties)
                if ((code+1 )=== number) {
                    return true
                }
                return false
            },

            //xl
            editXlDistrict(party){
                this.not.notDialog(true,false,null,"This option is currently not available. Please, edit from the file","OK")
            },
            deleteXlDistrict(party){
                this.not.notDialog(true,true,"REMOVE PARTY","Are you sure, you want to remove this party from upload list","CANCEL","REMOVE",{
                    code:pageName+"=REMOVE-XL-PARTY",
                    party:party
                }) 
            },
            uploadXl(){
                this.not.notDialog(true,true,"UPLOAD TO LIST","Upload to already existing list","CANCEL","UPLOAD",{
                    code:pageName+"=XL-UPLOAD-OLD",
                    parties:this.EXCEL_JS_parties
                }) 
            },
            uploadXlNew(){
                let isOk = this.not.CODE_IS_OK(this.EXCEL_JS_parties) 
                if (!isOk) { 
                    this.not.notDialog(true,true,"CODE ERROR","Please, make sure each party has a valid unique code. you can fix this by clicking AUTO GENERATE CODE button, to auto generate code.","CANCEL","AUTO GENERATE CODE",{
                        code:pageName+"=AUTO-GENERATE-CODE",
                        data:this.EXCEL_JS_parties
                    }) 

                    return 
                } 
                this.input.check = true 
                this.not.notDialog(true,true,"UPLOAD NEW LIST","the current parties list will be overridden with this new list","CANCEL","UPLOAD",{
                    code:pageName+"=XL-UPLOAD-NEW",
                    parties:this.EXCEL_JS_parties
                }) 
            },

            //-----------------[SELECT FILE]-----------
            onExcelSelect(type){  
                let p = this.accessParties("write")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you have no parties write permission. Contact system admin for more info.","OK") 
                } else {
                    this.dialog_add_party = false
                    this.excelSelecter = !this.excelSelecter
                } 
                
            }, 
            fileSelected(wb){
                this.WB = wb
                this.excelSelecter = false
                this.EXCEL_JS_parties=[] 

                let ws_parties = wb.Sheets["parties"]  
                if (!ws_parties) {
                    this.not.notDialog(true,true,"ERROR","The select file does not contain parties work sheet. Please, make sure you selected the right file and try again","CANCEL","TRY AGAIN",{
                        code:pageName+"=SELECT-EXCEL"
                    })
                } else {
                    let districts = this.XLSX.utils.sheet_to_json(ws_parties)  
                    let jn_parties = []
                    let number = 0
                    districts.forEach(cs => {
                        let dt = new Date
                        let date = dt.toISOString()
                        number = number+1 

                        jn_parties.push({
                            code:cs.code,
                            name:cs.name?cs.name:'',
                            party_short_name:cs.party_short_name?cs.party_short_name:'',
                            color_code:cs.color_code?cs.color_code:'',
                            image_link:cs.image_link?cs.image_link:'',
                            created_at:date,
                            uid:this.us.uid,
                            no:number
                        })
                    });
                    this.EXCEL_JS_parties = jn_parties
                    this.dialog_selected_parties = true
                    
                }
            },

            //-----------------[PAGE CONTRAL]---------
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/parties'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/party'
                        })  
                        let updating = ps.find(process=>{
                            return process.name == 'updating/party'
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/party'
                        }) 
                        let setting = ps.find(process=>{
                            return process.name == 'setting/parties'
                        }) 

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting) {
                            this.page_show_parties =false
                            this.not.notDialogP(true,false,'Loading...')
                        }else{
                            this.page_show_parties =true
                        }

                        
                        if (adding) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }  
                        if (updating) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }  
                        if (deleting) {
                            this.not.notDialogP(true,false,'Deleting...') 
                        }else{ 
                        }  
                        if (setting) {
                            this.not.notDialogP(true,false,'Uploading...')
                            this.input.loading = true
                        }else{ 
                        } 

                        //IF ALL DONE
                        if (ps.length===0) { 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                            this.not.notDialogP(false)
                        }
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false)
                    }

                    //check response
                    if (res.res==='adding/party/successful') { 
                        this.not.notDialog(true,true,'Successful','party successfully added.','','OK',{code:pageName+'=ADD-PARTY-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='adding/party/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding the party. make sure your password is correct or contact admin','','OK',{code:pageName+'=ADD-PARTY-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 


                     if (res.res==='updating/party/successful') { 
                        this.not.notDialog(true,true,'Successful','party successfully edited.','','OK',{code:pageName+'=EDIT-PARTY-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='updating/party/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the party. make sure your password is correct or contact admin','','OK',{code:pageName+'=EDIT-PARTY-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                     
                    if (res.res==='deleting/party/successful') { 
                        this.not.notDialog(true,true,'Successful','party successfully deleted.','','OK',{code:pageName+'=DELETE-USER-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='deleting/party/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting the party. make sure your password is correct or contact admin','','OK',{code:pageName+'=DELETE-USER-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                    if (res.res==='setting/parties/successful') { 
                        this.not.notDialog(true,true,'Successful','parties successfully upload.','','OK',{code:pageName+'=SETTING-PARTY-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_selected_parties = false
                    }else if (res.res==='setting/parties/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while uploading the parties. ','','OK',{code:pageName+'=SETTING-PARTY-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                        this.dialog_selected_parties = false
                    } 
 
                },t)
            }
        }, 
        watch: {
            us(v){
                this.pageLoad(1)
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
